import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Hervorgehobenen Tagen wurde kein Buchstabe zugewiesen.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Zuordnung Buchstaben", -1)
const _hoisted_5 = { class: "tags are-medium" }
const _hoisted_6 = {
  key: 0,
  class: "tag is-warning"
}
const _hoisted_7 = {
  key: 1,
  class: "tag is-info"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Zuordnung Bilder", -1)
const _hoisted_9 = { class: "tags are-medium" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Alle Türchen", -1)
const _hoisted_11 = { class: "tags are-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiModal = _resolveComponent("MultiModal")!
  const _component_BulmaButton = _resolveComponent("BulmaButton")!
  const _component_BulmaDrawer = _resolveComponent("BulmaDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MultiModal, { onHandle: _ctx.modal_handle }, null, 8, ["onHandle"]),
    _createVNode(_component_BulmaDrawer, {
      header: "Kalender-Assistent",
      onOpen: _ctx.on_open,
      refreshable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.day_data, (data, day) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `part-${day}`
                }, [
                  (data.part === '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(day), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(day) + ": " + _toDisplayString(data.part.split("").join(", ")), 1))
                ], 64))
              }), 128))
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.day_data, (data, day) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `image-${day}`,
                  class: _normalizeClass('tag is-' + (data.part === '' ? 'warning' : 'primary'))
                }, _toDisplayString(day) + ": " + _toDisplayString(data.image_name), 3))
              }), 128))
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.day_data, (data, day) => {
                return (_openBlock(), _createBlock(_component_BulmaButton, {
                  key: `btn-${day}`,
                  class: _normalizeClass('tag is-' + (data.part === '' ? 'warning' : 'info')),
                  icon: "fa-solid fa-door-open",
                  text: day,
                  onClick: _withModifiers(($event: any) => (_ctx.door_click(day)), ["left"])
                }, null, 8, ["class", "text", "onClick"]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onOpen"])
  ], 64))
}